export default __webpack_public_path__ + "static/media/logoslide.234a41d3.png";